import { all, takeEvery } from 'redux-saga/effects';

import services from '../services';
import EntryActionTypes from '../../../constants/EntryActionTypes';

export default function* cardsWatchers() {
  yield all([
    takeEvery(EntryActionTypes.CARD_CREATE, ({ payload: { listId, data, autoOpen } }) =>
      services.createCard(listId, data, autoOpen),
    ),
    takeEvery(EntryActionTypes.CARD_CREATE_HANDLE, ({ payload: { card } }) =>
      services.handleCardCreate(card),
    ),
    takeEvery(EntryActionTypes.CARD_UPDATE, ({ payload: { id, data } }) =>
      services.updateCard(id, data),
    ),
    takeEvery(EntryActionTypes.CURRENT_CARD_UPDATE, ({ payload: { data } }) =>
      services.updateCurrentCard(data),
    ),
    takeEvery(EntryActionTypes.CARD_UPDATE_HANDLE, ({ payload: { card } }) =>
      services.handleCardUpdate(card),
    ),
    takeEvery(EntryActionTypes.CARD_MOVE, ({ payload: { id, listId, index } }) =>
      services.moveCard(id, listId, index),
    ),
    takeEvery(EntryActionTypes.CURRENT_CARD_MOVE, ({ payload: { listId, index } }) =>
      services.moveCurrentCard(listId, index),
    ),
    takeEvery(EntryActionTypes.CARD_TRANSFER, ({ payload: { id, boardId, listId, index, pointSystemOptions } }) =>
      services.transferCard(id, boardId, listId, index, pointSystemOptions),
    ),
    takeEvery(EntryActionTypes.CURRENT_CARD_TRANSFER, ({ payload: { boardId, listId, index, pointSystemOptions } }) =>
      services.transferCurrentCard(boardId, listId, index, pointSystemOptions),
    ),
    takeEvery(EntryActionTypes.CARD_TRANSFER_POINT_SYSTEM_CONFIRM, ({ payload: { enable } }) =>
      services.confirmCardTransferPointSystem(enable),
    ),
    takeEvery(EntryActionTypes.CARD_ARCHIVE, ({ payload: { id } }) => services.archiveCard(id)),
    takeEvery(EntryActionTypes.CURRENT_CARD_ARCHIVE, () => services.archiveCurrentCard()),
    takeEvery(EntryActionTypes.CARD_ARCHIVE_HANDLE, ({ payload: { card } }) =>
      services.handleCardArchive(card),
    ),
    takeEvery(EntryActionTypes.CARD_RESTORE, ({ payload: { id } }) => services.restoreCard(id)),
    takeEvery(EntryActionTypes.CARD_RESTORE_HANDLE, ({ payload: { card } }) =>
      services.handleCardRestore(card),
    ),
    takeEvery(EntryActionTypes.CARD_CLONE, ({ payload: { id } }) => services.cloneCard(id)),
    takeEvery(EntryActionTypes.CURRENT_CARD_CLONE, () => services.cloneCurrentCard()),
    takeEvery(EntryActionTypes.CARD_CLONE_HANDLE, ({ payload: { card } }) => 
      services.handleCardClone(card),
    ),
    takeEvery(EntryActionTypes.CARD_DELETE, ({ payload: { id } }) => services.deleteCard(id)),
    takeEvery(EntryActionTypes.CURRENT_CARD_DELETE, () => services.deleteCurrentCard()),
    takeEvery(EntryActionTypes.CARD_DELETE_HANDLE, ({ payload: { card } }) =>
      services.handleCardDelete(card),
    ),
  ]);
}
